const WORDS = ["Show up", "Put in the work", "Track it", "Keep improving", "Train together", "Stay accountable"];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {WORDS.map((w, i) => (
      <span key={w} className="flex items-center">
        <span className={`font-display text-6xl font-black uppercase tracking-tight sm:text-8xl ${i % 2 ? "text-outline" : "text-[#f2f3f5]"}`}>{w}</span>
        <span className="mx-8 h-3 w-3 rotate-45 bg-grad sm:mx-12" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section data-testid="brand-marquee" className="marquee-wrap overflow-hidden border-y border-white/[0.07] py-8 sm:py-10" aria-label="Spotter mantra">
    <div className="marquee-track"><Row /><Row /></div>
  </section>
);
